// @flow

import React from "react";
import { connect } from "react-redux";
import colors from "@src/common/colors";

import { VerticalSteps, Text, Flex } from "@src/common";

const { Step, SubSection } = VerticalSteps;

class Stepper extends React.Component {
  render() {
    const steps = [
      this.props.sections.riskindicators,
      this.props.sections.riskratings,
      this.props.sections.contributingfactors
    ];

    return (
      <div>
        <VerticalSteps
          activeStep={this.props.stepsMeta.activeStep}
          autoHideContent
        >
          {/* Render the steps, some steps contain substeps, render those as nested steps */}
          {steps.map(
            (step, idx) =>
              (step.subsections
                ? <Step
                    key={idx}
                    label={
                      <Flex paddingL="1" justifyContent="flex-start">
                        <Text size="4">{step.title}</Text>
                      </Flex>
                    }
                    bullet={step.label}
                  >
                    <Flex
                      paddingL="1"
                      flexDirection="column"
                      alignItems="flex-start"
                    >
                      <Text type="medium" size="5" paddingB="1">
                        Description
                      </Text>
                      <Text size="5" lineHeight="1.5" style={{ width: "100%" }}>
                        {step.description}
                      </Text>
                    </Flex>
                    <SubSection activeStep={this.props.stepsMeta.activeSubStep}>
                      {step.subsections.map((substep, idx) => (
                        <Step
                          key={idx}
                          label={
                            <Text type="medium" size="5">
                              {idx + 1}. {substep.title}
                            </Text>
                          }
                          completeColor={colors.darkBlue}
                          activeColor={colors.darkBlue}
                          waitingColor={colors.black}
                        />
                      ))}
                    </SubSection>
                  </Step>
                : <Step
                    key={idx}
                    label={
                      <Flex paddingL="1" justifyContent="flex-start">
                        <Text size="4">{step.title}</Text>
                      </Flex>
                    }
                    bulletTextType="medium"
                    bullet={step.label}
                  >
                    <Flex
                      paddingL="1"
                      flexDirection="column"
                      alignItems="flex-start"
                    >
                      <Text type="medium" size="5" paddingB="1">
                        Description
                      </Text>
                      <Text size="5" lineHeight="1.5" style={{ width: "100%" }}>
                        {step.description}
                      </Text>
                    </Flex>
                  </Step>)
          )}
        </VerticalSteps>
      </div>
    );
  }
}

function mapStateToProps(store) {
  return {
    stepsMeta: store.sideBar.stepsMeta,
    sections: store.app.sections
  };
}

export default connect(mapStateToProps)(Stepper);



// WEBPACK FOOTER //
// ./src/containers/Assessment/Sidebar/components/Stepper.jsx